import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import React, { Component } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import TablePagination from '@material-ui/core/TablePagination';
import DataTable from './DataTable';

var PaginatedDynamicDataTable =
/*#__PURE__*/
function (_Component) {
  _inherits(PaginatedDynamicDataTable, _Component);

  function PaginatedDynamicDataTable(props) {
    var _this2;

    _classCallCheck(this, PaginatedDynamicDataTable);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PaginatedDynamicDataTable).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this2));

    _this2.state = {
      offset: 0,
      total: 0,
      limit: 10,
      updating: true,
      sort: undefined,
      text: undefined
    };

    _this2.load(props);

    return _this2;
  }

  _createClass(PaginatedDynamicDataTable, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          docs = _this$state.docs,
          total = _this$state.total,
          limit = _this$state.limit,
          page = _this$state.page,
          updating = _this$state.updating;
      var _this$props = this.props,
          title = _this$props.title,
          mapping = _this$props.mapping,
          link = _this$props.link,
          empty = _this$props.empty,
          multiSelectId = _this$props.multiSelectId,
          onSelectionChange = _this$props.onSelectionChange,
          tableActions = _this$props.tableActions,
          tableSelectionActions = _this$props.tableSelectionActions,
          search = _this$props.search;
      return React.createElement(React.Fragment, null, React.createElement(LinearProgress, {
        style: updating ? {} : {
          visibility: 'hidden'
        }
      }), React.createElement(React.Fragment, null, React.createElement(DataTable, {
        docs: docs,
        mapping: mapping,
        link: link,
        onSort: this.handleColumnSort,
        multiSelectId: multiSelectId,
        onSelectionChange: onSelectionChange,
        tableActions: tableActions,
        tableSelectionActions: tableSelectionActions,
        title: title,
        search: search,
        searchLive: search === 'live',
        searchFunction: this.handleSearch,
        empty: empty
      }), !((docs === undefined || docs.length === 0) && empty !== undefined) && React.createElement(TablePagination, {
        component: 'div',
        count: total,
        rowsPerPage: limit,
        page: page - 1,
        backIconButtonProps: {
          'aria-label': 'Previous Page'
        },
        nextIconButtonProps: {
          'aria-label': 'Next Page'
        },
        onChangePage: this.handleChangePage,
        onChangeRowsPerPage: this.handleChangeRowsPerPage
      })));
    }
  }]);

  return PaginatedDynamicDataTable;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  var _this = this;

  this.load = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(props) {
      var _ref3, provider, _this$state2, offset, limit, sort, text, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref3 = props || _this.props, provider = _ref3.provider;
              _this$state2 = _this.state, offset = _this$state2.offset, limit = _this$state2.limit, sort = _this$state2.sort, text = _this$state2.text;
              _context.next = 4;
              return provider(offset, limit, sort, text);

            case 4:
              data = _context.sent;

              _this.setState(_extends({}, data, {
                updating: false
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.handleChangePage = function (event, page) {
    var _this3$state = _this3.state,
        limit = _this3$state.limit,
        offset = _this3$state.offset;

    if (offset !== page * limit) {
      _this3.setState({
        offset: page * limit,
        updating: true
      }, _this3.load);
    }
  };

  this.handleChangeRowsPerPage = function (event) {
    var limit = _this3.state.limit;

    if (limit !== event.target.value) {
      _this3.setState({
        limit: event.target.value,
        offset: 0,
        updating: true
      }, _this3.load);
    }
  };

  this.handleColumnSort = function (order, column) {
    if (order === undefined || column === undefined) {
      _this3.setState({
        sort: undefined,
        updating: true
      }, _this3.load);
    } else {
      _this3.setState({
        sort: "".concat(column, ":").concat(order),
        updating: true
      }, _this3.load);
    }
  };

  this.handleSearch = function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(text) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState(_extends({}, _this.state, {
                updating: true
              }, text === '' ? {
                text: undefined
              } : {
                text: text
              }), _this.load);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export default PaginatedDynamicDataTable;